import { ComponentType, FC, PropsWithChildren } from 'react';
import AccessDenied from './403';
import { usePermissionStore } from '../../store/permission';

interface PermissionCheckProps {
  resources: string[];
  redirect?: boolean;
  checkOwner?: boolean;
}

export const Permission: FC<PropsWithChildren<PermissionCheckProps>> = (props) => {
  const permissionStore = usePermissionStore((state) => ({
    owner: state.owner,
    permit: state.checkPermissionNew(props.resources),
  }));

  if ((permissionStore.owner && !props.checkOwner) || permissionStore.permit) {
    return <>{props.children}</>;
  } else if (props.redirect) {
    return <AccessDenied />;
  } else {
    return <></>;
  }
};

export function withPermission<P extends {}>(WrappedComponent: ComponentType<P>, resources: string[]) {
  return (props: P) => (
    <Permission resources={resources} redirect>
      <WrappedComponent {...props} />
    </Permission>
  );
}
